// Auto-generated OTLP resource attribute keys.

export const OTLP_RESOURCE_ATTRIBUTES = {
  serviceName: "service.name",
  serviceVersion: "service.version",
  telemetrySdkName: "telemetry.sdk.name",
  telemetrySdkLanguage: "telemetry.sdk.language",
  telemetrySdkVersion: "telemetry.sdk.version",
  octomilOrgId: "octomil.org.id",
  octomilDeviceId: "octomil.device.id",
  octomilPlatform: "octomil.platform",
  octomilSdkSurface: "octomil.sdk.surface",
  octomilInstallId: "octomil.install.id",
  octomilDeviceClass: "octomil.device.class",
  octomilAvailableRuntimes: "octomil.available_runtimes",
  octomilAccelerators: "octomil.accelerators",
} as const;
